'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initNotification = initNotification;

var _keyMappings = require('@fr/key-mappings');

var _docCookies = require('doc-cookies');

var _docCookies2 = _interopRequireDefault(_docCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sets the cookie to avoid showing a one timer notification twice.
 *
 * @param {string} cookieName The name of the cookie.
 */
/**
 * Notification aims to prompt the user with information, feedback or
 * confirmation.
 * It can be dismissed by clicking on the close button.
 */

var persistChoice = function persistChoice(cookieName) {

  var date = new Date();

  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);

  _docCookies2.default.setItem(cookieName, 'T', date.toGMTString(), '/');
};

/**
 * Initalizes a given DOM element into a notification component.
 *
 * @param {object} notification The DOM element to turn into notification
 *                              component.
 */
function initNotification(notification) {

  // NOTIFICATION
  if (notification) {

    var info = notification.querySelector('.js-notification__info'),
        button = notification.querySelector('.js-notification__close'),
        isAlert = notification.classList.contains('js-notification--alert'),
        isOneTimer = notification.getAttribute('data-cookie') ? true : false;

    if (notification.style.display != 'none') {
      throw new Error('A notification should not be visible by default');
    }

    if (isOneTimer) {

      // If the cookie has been already set, remove the markup and do not bother
      // initializing the notification.
      if (_docCookies2.default.getItem(notification.getAttribute('data-cookie'))) {
        notification.parentNode.removeChild(notification);
        return;
      }
    }

    // Show the notification.
    notification.style.display = '';

    // INFO
    if (info) {
      info.setAttribute('role', isAlert ? 'alert' : 'status');
      info.setAttribute('aria-live', isAlert ? 'assertive' : 'polite');
    } else {
      throw new Error('Missing notification info child element');
    }

    // BUTTON
    if (button) {

      // Fixes accessibility issue in case the close toggle is no native button.
      if (button.tagName !== 'BUTTON') {

        if (button.tagName === 'A') {
          button.setAttribute('href', '#');
        } else {
          button.setAttribute('tabindex', '0');
        }

        button.setAttribute('role', 'button');
      }

      // Mouse interaction.
      button.addEventListener('click', function (event) {

        event.preventDefault();

        notification.parentNode.removeChild(notification);

        if (isOneTimer) {
          persistChoice(notification.getAttribute('data-cookie'));
        }
      });

      // Keyboard interactions.
      button.addEventListener('keydown', function (event) {

        if (event.keyCode === _keyMappings.ENTER_KEY || event.keyCode === _keyMappings.SPACE_KEY) {

          event.preventDefault();

          notification.parentNode.removeChild(notification);
        }

        if (isOneTimer) {
          persistChoice(notification.getAttribute('data-cookie'));
        }
      });
    } else {
      throw new Error('Missing notification close button child element');
    }
  } else {
    throw new Error('Notification element should not be null|undefined');
  }
}